// @flow
import { map, path, pipe } from 'lodash/fp';
import { head, isEmpty, tail, uniq } from 'lodash';

import { constants } from '@clubmed/utils';

import { t } from 'Src/i18n';
import { LEGAL_INFO_CGV_ID } from 'Utils/booking-process/constants';

const { PRODUCT_TYPES } = constants;

const getCGVFromLegalInfos = (
  bookingProcess: $ReadOnlyArray<LegalInformation>,
): LegalInformation => {
  // $FlowFixMe
  return (bookingProcess || []).find(bp => bp.id === LEGAL_INFO_CGV_ID) || { label: '' };
};

function getCarriersLabels(journey: ?TransportDetail): Array<string> {
  return pipe([path('travelSections') || [], map(path('transport.companyOperator.label'))])(
    journey,
  );
}

const getCarriersLabel = (inbound: ?TransportDetail, outbound: ?TransportDetail): string => {
  const uniqCarriers = uniq([...getCarriersLabels(inbound), ...getCarriersLabels(outbound)]);
  const firstCarrier = head(uniqCarriers);
  const lastCarriers = tail(uniqCarriers);

  return !isEmpty(lastCarriers)
    ? lastCarriers.join(', ').concat(` {lastSeparator} ${firstCarrier}`)
    : firstCarrier;
};

const tAlt = ({
  resortKeyPath,
  cruiseKeyPath,
  resort,
  variables,
}: {
  resortKeyPath: string,
  cruiseKeyPath: string,
  resort: Resort,
  variables?: { [string]: string | number },
}) => {
  return t(resort.type === PRODUCT_TYPES.CRUISE ? cruiseKeyPath : resortKeyPath, variables);
};

export { getCGVFromLegalInfos, getCarriersLabel, tAlt };
